import React from 'react'
import { Link } from 'react-router'
import { Label } from 'react-bootstrap'
import Icon from './icon'
import TopTooltip from './topTooltip'
import getDisplayName from '_/utils/getDisplayName'
import dateToString from '_/utils/dateToString'

class Listing extends React.Component {
  static propTypes = {
    isActive: React.PropTypes.bool,
    onCheck: React.PropTypes.func.isRequired,
    onModalOpen: React.PropTypes.func.isRequired,
    transaction: React.PropTypes.object.isRequired,
    transactionType: React.PropTypes.string.isRequired
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  checkValue (val, unit) {
    let rVal

    if (val) {
      rVal = val

      if (unit) {
        if (unit === '$') {
          rVal = `${unit}${rVal}`
        }
        else {
          rVal = `${rVal}${unit}`
        }
      }
    }
    else {
      rVal = 'N/A'
    }

    return rVal
  }

  handleCheck (evt) {
    const { transaction, onCheck } = this.props
    onCheck(transaction.get('id'))
  }

  handleModalShow (evt) {
    evt.preventDefault()
    const { transaction, onModalOpen } = this.props
    onModalOpen(transaction.get('id'), transaction.getIn(['properties', 0, 'id']))
  }

  renderTools () {
    const {
      isActive,
      transaction,
      transactionType
    } = this.props

    const propId = transaction.getIn(['properties', 0, 'id'])

    return (
      <div className="summaryTools pull-left">
        <div className="tool">
          <div className="btn btn-xs">
            <input
              type="checkbox"
              onChange={::this.handleCheck}
              checked={isActive} />
          </div>
        </div>

        <div className="tool">
          <TopTooltip content="View summary">
            <a href="#" className="btn btn-xs text-warning" onClick={::this.handleModalShow}>
              <Icon name="fa-clone" />
            </a>
          </TopTooltip>
        </div>

        <div className="tool">
          <TopTooltip content="View detailed">
            <Link className="btn btn-xs text-primary" to={transactionType.toLowerCase()} params={{id: propId, transId: transaction.get('id')}}>
              <Icon name="fa-file-text-o" />
            </Link>
          </TopTooltip>
        </div>
      </div>
    )
  }

  renderPhoto () {
    const { transaction } = this.props
    const propId = transaction.getIn(['properties', 0, 'id'])

    return (
      <div className="property-photo-container">
        <div className="text-center photo">
          <img src={`/api/v1/properties/${propId}.jpg`} />
        </div>
      </div>
    )
  }

  renderSaleT() {
    const {transaction} = this.props
    if (!transaction.get('saleT')) {
      return null
    }

    return (
      <Label
        bsStyle={transaction.get('saleT') === 'Sold' ? 'danger' : 'success'}
        style={{marginRight: 5}}
      >
        {transaction.get('saleT')}
      </Label>
    )
  }

  renderDetails () {
    const { transaction, transactionType } = this.props
    let details

    switch (transactionType) {
      case 'Sale'   : details = this.getSaleDetails(); break
      case 'Lease'  : details = this.getLeaseDetails(); break
      case 'IncExp' : details = this.getIncExpDetails(); break
      case 'Const'  : details = this.getConstDetails(); break
      default       : details = null
    }

    return (
      <div className="property-body">
        <h4 className="title">
          {transactionType === 'Sale' && this.renderSaleT()}
          {getDisplayName('property', transaction.getIn(['properties', 0]))}
        </h4>
        {details}
      </div>
    )
  }

  renderItem (title, value, addon) {
    return (
      <p className="small">
        <strong>{title}:</strong> {this.checkValue(value)}{addon}
      </p>
    )
  }

  getSaleDetails () {
    const { transaction } = this.props
    const isAg = transaction.getIn(['properties', 0, 'genUseTM']).contains('Agriculture')

    let totalGbaLandStr = ''
    totalGbaLandStr += `GBA = ${this.checkValue(transaction.get('saleGbaSf'), '/Sf')}`
    totalGbaLandStr += ' ~ '
    totalGbaLandStr += `Land = ${this.checkValue(transaction.get('saleLandSf'), '/Sf')}`
    totalGbaLandStr += ' ~ '
    totalGbaLandStr += `Acres = ${this.checkValue(transaction.get('totalAcreCt'))}`

    const perSfPxStr = isAg
                        ? transaction.get('perAcrePx') ? ` ~ $${transaction.get('perAcrePx')}/acre` : ''
                        : transaction.get('perSfPx') ? ` ~ ${transaction.get('perSfPx')}/Sf` : ''

    return (
      <div>
        <p className="small text-muted">
          {totalGbaLandStr}
        </p>

        <hr />

        {this.renderItem('Close/list date', dateToString(transaction.get('closeDt')))}
        {this.renderItem('Price', transaction.get('salePx'), perSfPxStr)}
        {this.renderItem('Property use', (transaction.get('useTM') || []).join(', '))}
        {this.renderItem('Zoning', transaction.getIn(['properties', 0, 'zoning']))}
      </div>
    )
  }

  getLeaseDetails () {
    const { transaction } = this.props

    let askRentStr = ''
    if (transaction.get('askRentLPx') || transaction.get('askRentHPx')) {
      askRentStr = `${this.checkValue(transaction.get('askRentLPx'), '$')} - ${this.checkValue(transaction.get('askRentHPx'), '$')}`
    }
    else {
      askRentStr = 'N/A'
    }

    return (
      <div>
        <hr />

        {this.renderItem('Start/list date', dateToString(transaction.get('leaseStDt')))}
        {this.renderItem('Asking rent', askRentStr)}
        {this.renderItem('Rent per sq ft', transaction.get('rentSfPx'))}
        {this.renderItem('Property use', (transaction.get('useTM') || []).join(', '))}
        {this.renderItem('Zoning', transaction.getIn(['properties', 0, 'zoning']))}
      </div>
    )
  }

  getIncExpDetails () {
    const { transaction } = this.props

    return (
      <div>
        <hr />

        {this.renderItem('Start year', transaction.get('incStYr'))}
        {this.renderItem('End year', transaction.get('incEndYr'))}
        {this.renderItem('Ann gross inc', transaction.get('grossIncPx'))}
        {this.renderItem('Property use', (transaction.get('useTM') || []).join(', '))}
        {this.renderItem('Zoning', transaction.getIn(['properties', 0, 'zoning']))}
      </div>
    )
  }

  getConstDetails () {
    const { transaction } = this.props

    return (
      <div>
        <hr />

        {this.renderItem('Const. year', transaction.get('constYr'))}
        {this.renderItem('Const. price', transaction.get('constPx'))}
        {this.renderItem('Const. type', transaction.get('constT'))}
        {this.renderItem('Property use', (transaction.get('useTM') || []).join(', '))}
        {this.renderItem('Zoning', transaction.getIn(['properties', 0, 'zoning']))}
      </div>
    )
  }

  render() {
    const { isActive } = this.props

    let clsName = 'property-listing'
    if (isActive) clsName += ' active'

    return (
      <div className={clsName}>
        {this.renderTools()}
        {this.renderPhoto()}
        {this.renderDetails()}
      </div>
    )
  }
}

export default Listing



// WEBPACK FOOTER //
// ./modules/shared/components/listing.js